<template>
    <div class="draw-new-box" @click="goDrawInfo">
        <img class="draw-new-img" :src="imgUrlFilter(drawInfo.img, 187 * radio)" />
        <div class="cont">
            <div class="tit">{{drawInfo.title}}</div>
        </div>
    </div>
    <el-dialog v-model="qrcodeVisible" title="查看详情" :width="420">
        <div class="qrcode">
            <img :src="qrcode" />
            <span>微信扫一扫，查看详情</span>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button type="primary" @click="qrcodeVisible = false">确定</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import imgUrlFilter from 'md-base-tools/imgUrlFilter'
import { domPixelRatio } from 'md-base-tools/env'
import { getMiniAppQrcode } from "@api/index"
import { ElMessageBox, ElLoading } from "element-plus";
export default {
    props: {
        drawInfo: {
            type: Object
        }
        // drawId: { // 投票id
        //     type: String
        // },
        // drawImage: {
        //     type: String
        // },
        // drawTitle: {
        //     type: String
        // }
    },
    // computed: {
    //     showImg() {
    //         return this.drawImage || this.img
    //     },
    //     showTit() {
    //         return this.drawTitle || this.tit
    //     }
    // },
    // watch: {
    //     "drawId": {
    //         handler: function(val) {
    //             if (val) {
    //                 this.getDrawInfo()
    //             }
    //         },
    //         immediate: true,
    //         deep: true
    //     }
    // },
    data() {
        return {
            radio: parseInt(domPixelRatio()) || 1,
            // img: '',
            // tit: '',
            // update_id: 0,
            qrcodeVisible:false,
            qrcode: '',
            qrcodeList: []
        }
    },
    methods: {
        goDrawInfo() {
            const qrcodeDraw = this.qrcodeList.find(obj => obj.activity_id === this.drawInfo.drawId);
            if (qrcodeDraw) {
                this.qrcode = qrcodeDraw.qrcode;
                this.qrcodeVisible = true;
            } else if (this.drawInfo.update_id > 0) {
                location.href = '/project/update/detail/' + this.drawInfo.update_id
            }else{
                const loading = ElLoading.service({
                    lock: true,
                    text: '请求中',
                })
                let option = {
                    page: 'pages/prize/detail/detail',
                    scene: 'activity_id='+this.drawInfo.drawId
                }
                getMiniAppQrcode(option).then(res => {
                    loading.close()
                    if(res.status == 0){
                        this.qrcodeList.push({
                            activity_id:this.drawInfo.drawId,
                            qrcode:res.data.qrcode
                        })
                        this.qrcode = res.data.qrcode;
                        this.qrcodeVisible = true;
                    }else{
                        ElMessageBox.alert(res.message, '提示', {
                            confirmButtonText: '确定'
                        })
                    }
                })
            }
        },
        imgUrlFilter() {
            return imgUrlFilter(...arguments)
        },
        // getDrawInfo() {
        //     if(this.drawImage && this.drawTitle) return
        //     getNewDrawInfo({
        //         activity_id: this.drawId
        //     }).then(res => {
        //         if (res.status == 0) {
        //             this.img = res.data.img
        //             this.tit = res.data.title
        //             this.update_id = res.data.update_id
        //         }
        //     })
        // }
    }
}
</script>

<style lang="scss" scoped>
.draw-new-box {
    cursor: pointer;
    margin: 20px auto 0;
    width: 690px;
    height: 100px;
    border-radius: 12px;
    background: #F8F8F8;
    color: #1A1A1A;
    display: flex;
    align-items: center;
    line-height: 1;
    font-size: 28px;
    position: relative;
    padding: 10px;
    overflow: hidden;
    border: 1px solid #80CAFF;
    box-sizing: border-box;
    &::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 58px;
        height: 30px;
        background: url('https://p6.moimg.net/mdwxapp/draw_new_card_logo.png') no-repeat center center;
        background-size: contain;
    }
    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        right: 16px;
        width: 88px;
        height: 68px;
        background: url('https://p6.moimg.net/mdwxapp/draw_new_card_bg.png') no-repeat center center;
        background-size: contain;
    }
    .gift_bg,.btn{
        display: none;
    }
    img{
        width: 80px;
        height: 80px;
        border-radius: 12px;
        margin: 0 10px 0 0;
    }
    .cont{
        flex: 1;
        width: 0;
        p{
            display: none;
            &.title{
                display: block;
                font-size: 28px;
                font-weight: 500;
                line-height: 1.5;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
    ::v-deep(.el-dialog){
        .el-dialog__header{
            height:60px;
            padding:0;
            margin: 0 30px;
            font-size: 20px;
            font-weight: 600;
            line-height: 60px;
            color: #1A1A1A;
            border-bottom: 1px solid #E8E8E8;
        }
        .el-dialog__body{
            padding:20px 30px;
            .qrcode{
                display:flex;
                align-items:center;
                flex-direction:column;
                justify-content: space-between;
                img{
                    margin:16px 0 0 0;
                    width: 200px;
                    height: 200px;
                }
                span{
                    font-size: 16px;
                    padding:10px 0 0 0;
                    font-weight: 400;
                    color: #7F7F7F;
                    line-height: 16px;
                }
            }
        }
        .el-dialog__footer{
            .dialog-footer{
                display:flex;
                align-items:center;
                justify-content: end;
            }
        }
    }
}
</style>
